<nav class="flex nowrap font-body-1">
  <ul class="flex no-list-style">
    <li class="ps-medium-x ps-xxsmall-t ps-small-b" routerLinkActive="is-active">
      <a [routerLink]="[baseUrl, 'home']">
        <span>
          {{ 'CORPORATE.corporatePortal.pages.home' | finLocalization }}
        </span>
      </a>
    </li>
    <li class="ps-medium-x ps-xxsmall-t ps-small-b" routerLinkActive="is-active">
      <a [routerLink]="[baseUrl, 'trips']">
        <span>
          {{ 'CORPORATE.corporatePortal.pages.trips' | finLocalization }}
        </span>
      </a>
    </li>
    <li
      class="ps-medium-x ps-xxsmall-t ps-small-b"
      routerLinkActive="is-active"
      *ngIf="enableCorporateSpend && (isAdmin$ | async)"
    >
      <a [routerLink]="[baseUrl, 'data']">
        <span>
          {{ 'CORPORATE.corporatePortal.pages.data' | finLocalization }}
        </span>
      </a>
    </li>
    <li class="ps-medium-x ps-xxsmall-t ps-small-b" routerLinkActive="is-active">
      <a [routerLink]="[baseUrl, 'users']" class="">
        <span *ngIf="isAdminOrTravelBooker$ | async">
          {{ 'CORPORATE.corporatePortal.pages.users' | finLocalization }}
        </span>
        <span *ngIf="(isAdminOrTravelBooker$ | async) === false">
          {{ 'CORPORATE.corporatePortal.pages.myProfile' | finLocalization }}
        </span>
      </a>
    </li>
    <li class="ps-medium-x ps-xxsmall-t ps-small-b" routerLinkActive="is-active">
      <a [routerLink]="[baseUrl, 'company']">
        <span>
          {{ 'CORPORATE.corporatePortal.pages.companyDetails' | finLocalization }}
        </span>
      </a>
    </li>
  </ul>
</nav>
